import {
    put, call, all, takeLatest, select
} from 'redux-saga/effects';
import { defaultSaga, getActions } from '../utils';

import * as constants from './constants';
import * as actions from './actions';
import * as api from './api';
import converter from './converter';

export default function* rootSaga() {
    yield all([
        yield takeLatest(
            constants.getCalculatorsYear.toString(),
            defaultSaga({
                constants: constants.getCalculatorsYear,
                api: api.getCalculatorsYear
            })
        ),
        yield takeLatest(
            constants.getCalculatorsYearItem.toString(),
            defaultSaga({
                constants: constants.getCalculatorsYearItem,
                api: api.getCalculatorsYearItem
            })
        )
    ]);
}